
import React from "react";
import { StyledLinkButton } from "./linkButton.style";

const LinkButton = (props) => {
	
	return (
		<StyledLinkButton {...props}/>
	);
};

export default LinkButton;
